export default function useDefaultExclusionCheck() {
  const shouldExclude = (entity) => entity.completelyLoaded === true;

  return { shouldExclude };
}
